import { Link } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import { useEffect, useState } from "react";

function HomePage() {
  const [featuredProducts, setFeaturedProducts] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const data = await fetch(`${process.env.REACT_APP_API_URL}/api/products`);
      const products = await data.json();
      setFeaturedProducts(products.filter((product) => product.featured));
    }
    fetchData();
  }, []);

  return (
    <div>
      <section className="hero">
        <h2>New Season, New Style</h2>
        <p>Curated clothing for women and children</p>
        <Link to="/women" className="hero-btn">
          Shop Women's
        </Link>
      </section>

      <section className="categories">
        <h2>Shop by Category</h2>
        <div className="category-grid">
          <Link to="/women" className="category-card">
            Women
          </Link>
          <Link to="/kids" className="category-card">
            Kids
          </Link>
        </div>
      </section>

      <section className="featured">
        <h2>Featured Products</h2>
        <div className="product-grid">
          {featuredProducts.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </section>
    </div>
  );
}

export default HomePage;
